import { render, staticRenderFns } from "./messageMailboxes.vue?vue&type=template&id=6fa43364&scoped=true"
import script from "./messageMailboxes.vue?vue&type=script&lang=js"
export * from "./messageMailboxes.vue?vue&type=script&lang=js"
import style0 from "./messageMailboxes.vue?vue&type=style&index=0&id=6fa43364&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa43364",
  null
  
)

export default component.exports